<serviceos-ng-alert [type]="settings.customize.type || 'error'">
    <p>
        {{settings.description}}
    </p>
</serviceos-ng-alert>